import Button from '../../components/ui/Button'
import PageHeader from '../../components/ui/PageHeader'
import { ui } from '../../styles/ui'
import ProviderEngineEditor from './ProviderEngineEditor'
import QueueSettingsSection from './QueueSettingsSection'
import LlmRoutingPromptAdmin from './LlmRoutingPromptAdmin'
import { QUEUE_KEYS, getQueuePromptLabel } from './queueConfig'

export default function LLMSettingsContent({
  t, message, engines, queueEngines, queueProcessing, queueToggleLoading, enginesSaved,
  saving, queuePromptValue, onEnginesChange, onQueueEngineChange, onPromptChange, onToggle, onSave,
}) {
  return <>
    <PageHeader title={t('Queue settings', 'Queue settings')}
      subtitle={t('Choose primary and fallback LLM engines for each queue independently.', 'Choose primary and fallback LLM engines for each queue independently.')} />
    {message && <div className={ui.alertInfo + ' mb-4'}>{message}</div>}
    <div className="space-y-6">
      <ProviderEngineEditor engines={engines} onChange={onEnginesChange} saved={enginesSaved} />
      <LlmRoutingPromptAdmin engines={engines} />
      <QueueSettingsSection queueKeys={QUEUE_KEYS} engines={engines} queueEngines={queueEngines}
        queueProcessing={queueProcessing} queueToggleLoading={queueToggleLoading} promptLabel={getQueuePromptLabel}
        promptValue={queuePromptValue} onQueueEngineChange={onQueueEngineChange} onPromptChange={onPromptChange} onToggle={onToggle} />
    </div>
    <div className="mt-6 flex justify-end"><Button type="button" onClick={onSave} disabled={saving}>
      {saving ? t('Saving...', 'Saving...') : t('Save queue engine settings', 'Save queue engine settings')}
    </Button></div>
  </>
}
